import CookieConsent from "../../Scalesoft.Shared.FrontEnd/Scripts/CookieConsent";
import LayoutUtils from "../../Scalesoft.Shared.FrontEnd/Scripts/LayoutUtils";
import LoadingBarsInitializer from "../../Scalesoft.Shared.FrontEnd/Scripts/LoadingBarsInitializer";
import LoginExpiration from "../../Scalesoft.Shared.FrontEnd/Scripts/LoginExpiration";
import LogoutManager from "../../Scalesoft.Shared.FrontEnd/Scripts/LogoutManager";
import PermissionChecker from "../../Scalesoft.Shared.FrontEnd/Scripts/PermissionChecker";
import "../../Scalesoft.Shared.FrontEnd/Scripts/StringExtension";
// Uncomment after solving problem with unsupported browser modal #IN2-8676
// import BrowserDetector from "./BrowserDetector";
import BirthDateRangeValidationExtension from "./Global/BirthDateRangeValidationExtension";
import IEFlexBoxWorkAround from "./IEFlexBoxWorkAround";
import LocalizationInitializer from "./Localization/LocalizationInitializer";
import NavbarUtils from "./NavbarUtils";
import NotificationSidebar from "./NotificationSidebar/NotificationSidebar";
import ResponsiveNavbarItemsList from "./ResponsiveNavbarItemsList";
import SelectFacility from "./SelectFacility";

new IEFlexBoxWorkAround().preinitOnLoad();

export default class MainLayout {
    private readonly navbarItemsList: ResponsiveNavbarItemsList;

    constructor(navbarItemsList: ResponsiveNavbarItemsList) {
        this.navbarItemsList = navbarItemsList;
    }

    public init(): void {
        PermissionChecker.init();

        if (LoginExpiration.canInit()) {
            const sessionExpiration = new LoginExpiration(jq);
            sessionExpiration.init();
            sessionExpiration.initFetch();
        }

        if (LogoutManager.requiredScriptElementExists()) {
            const logoutManager = new LogoutManager();
            logoutManager.appendEventListeners();
        }

        const utils = new LayoutUtils();
        utils.configureJqueryAjax();
        utils.updateAllLinks(jq);

        jq(".navbar-header .lang-dropdown-toggle").dropdown();

        const navbarUtils = new NavbarUtils();
        navbarUtils.toggleMenuCollapse();
        navbarUtils.toggleMenuItemExpansion();
        navbarUtils.attachHideTestingAlert();
        navbarUtils.trackWindowResize();

        const callPortalAndUpdateNavbar = (acceptedCategories: string[]): void => {
            window.dispatchEvent(new CustomEvent<string[]>("cookie-consent-change", {detail: acceptedCategories}));
        };

        const localizationInit = new LocalizationInitializer();
        localizationInit.init();

        const notificationSidebar = new NotificationSidebar(
            window.localization,
            jq,
        );
        notificationSidebar.init();

        const cookieContent = new CookieConsent(callPortalAndUpdateNavbar);
        cookieContent.init();

        const loadingBarInitialiser = new LoadingBarsInitializer();
        addEventListener("load", () => {
            loadingBarInitialiser.reinit();
        });
        loadingBarInitialiser.init();

        // Uncomment after solving problem with unsupported browser modal #IN2-8676
        // const browserDetector = new BrowserDetector();
        // browserDetector.unsupportedModalHandler();

        const birthDateRangeValidationExtension = new BirthDateRangeValidationExtension();
        birthDateRangeValidationExtension.init();

        const selectFacility = new SelectFacility();
        selectFacility.init();

        new IEFlexBoxWorkAround().initOnReady();
    }
}
